module.exports = __webpack_public_path__ + "media/introduction_3.eb2dd989.mp4";